import { render, staticRenderFns } from "./batchUpGradings.vue?vue&type=template&id=be1ceba0&scoped=true&"
import script from "./batchUpGradings.vue?vue&type=script&lang=js&"
export * from "./batchUpGradings.vue?vue&type=script&lang=js&"
import style0 from "./batchUpGradings.vue?vue&type=style&index=0&id=be1ceba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1ceba0",
  null
  
)

export default component.exports